import takeRequest from '~/store/takeRequest';

import * as CobrancaActions from './actions';

export function* cobrancaSaga(): Generator {
  // Dívida
  yield takeRequest(CobrancaActions.getDividaByContractId);
  yield takeRequest(CobrancaActions.getDivida);

  // Oferta
  yield takeRequest(CobrancaActions.getOfertaOpcoesPagamento);
  yield takeRequest(CobrancaActions.getOfertaStatus);
  yield takeRequest(CobrancaActions.solicitarOferta);
  yield takeRequest(CobrancaActions.confirmarOferta);

  // Ocorrência
  yield takeRequest(CobrancaActions.registrarOcorrencia);
  yield takeRequest(CobrancaActions.alegaPagamento);
  yield takeRequest(CobrancaActions.desconheceDivida);

  // Pix
  yield takeRequest(CobrancaActions.emitirPix);
  yield takeRequest(CobrancaActions.emitirPixParcelamento);
  yield takeRequest(CobrancaActions.emitirPixPorContrato);
  yield takeRequest(CobrancaActions.getTicketsCobranca);
  yield takeRequest(CobrancaActions.emitirPixPdf);
  yield takeRequest(CobrancaActions.emitirPixSms);
  yield takeRequest(CobrancaActions.emitirPixEmail);
  yield takeRequest(CobrancaActions.emitirPixOriginal);
  yield takeRequest(CobrancaActions.emitirPixOriginalPdf);

  // Parcelamento
  yield takeRequest(CobrancaActions.getParcelamento);
  yield takeRequest(CobrancaActions.cancelarParcelamento);

  // Proposta
  yield takeRequest(CobrancaActions.getPropostaStatus);
  yield takeRequest(CobrancaActions.getProposta);
  yield takeRequest(CobrancaActions.solicitarProposta);
  yield takeRequest(CobrancaActions.confirmarProposta);
}
